import React, { Component } from 'react'
import { Link } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'
import * as styles from './firstviewlist.module.css'

export default class FirstViewlist extends Component {

  render() {
    let targets
    switch (this.props.target) {
      /* 特集ページ一覧 */
      case 'bigtiti':
        targets = 
        <div className={styles.firstview_content}>
          <Link to='/bigtiti/'>
            <StaticImage
              formats={["AUTO", "WEBP", "AVIF"]}
              src="../../../images/captures/bigtiti.png"
              alt="巨乳・爆乳女優26選"
            />
            <p className={styles.firstview_content_title}>巨乳・爆乳女優26選</p>
          </Link>
        </div>
        break
      case 'bigass':
        targets = 
        <div className={styles.firstview_content}>
          <Link to='/bigass/'>
            <StaticImage
              formats={["AUTO", "WEBP", "AVIF"]}
              src="../../../images/captures/bigass.png"
              alt="巨尻・爆尻女優29選"
            />
            <p className={styles.firstview_content_title}>巨尻・爆尻女優29選</p>
          </Link>
        </div>
        break

      /* 個別記事の一覧 */
      case 'aisakiyua':
        targets = 
        <div className={styles.firstview_content}>
          <Link to='/sexyactress-aisaki-yua/'>
            <StaticImage
              formats={["AUTO", "WEBP", "AVIF"]}
              src="../../../images/captures/osakiyua.png"
              alt="逢咲ゆあの乳作品"
            />
            <p className={styles.firstview_content_title}>逢咲ゆあの乳作品</p>
          </Link>
        </div>
        break
      case 'ariokamiu':
        targets = 
        <div className={styles.firstview_content}>
          <Link to='/sexyactress-arioka-miu/'>
            <StaticImage
              formats={["AUTO", "WEBP", "AVIF"]}
              src="../../../images/captures/ariokamiu.png"
              alt="有岡みうの乳作品"
            />
            <p className={styles.firstview_content_title}>有岡みうの乳作品</p>
          </Link>
        </div>
        break
      case 'anzairara':
        targets = 
        <div className={styles.firstview_content}>
          <Link to='/sexyactress-anzai-rara/'>
            <StaticImage
              formats={["AUTO", "WEBP", "AVIF"]}
              src="../../../images/captures/anzairara.png"
              alt="安齋ららの乳作品"
            />
            <p className={styles.firstview_content_title}>安齋ららの乳作品</p>
          </Link>
        </div>
        break
      case 'egamishiho':
        targets = 
        <div className={styles.firstview_content}>
          <Link to='/sexyactress-egami-shiho/'>
            <StaticImage
              formats={["AUTO", "WEBP", "AVIF"]}
              src="../../../images/captures/egamishiho.png"
              alt="江上しほの尻作品"
            />
            <p className={styles.firstview_content_title}>江上しほの尻作品</p>
          </Link>
        </div>
        break
      case 'oshikawayuri':
        targets = 
        <div className={styles.firstview_content}>
          <Link to='/sexyactress-oshikawa-yuri/'>
            <StaticImage
              formats={["AUTO", "WEBP", "AVIF"]}
              src="../../../images/captures/oshikawayuri.png"
              alt="推川ゆうりの尻作品"
            />
            <p className={styles.firstview_content_title}>推川ゆうりの尻作品</p>
          </Link>
        </div>
        break
      case 'kitanomina':
        targets = 
        <div className={styles.firstview_content}>
          <Link to='/sexyactress-kitano-mina/'>
            <StaticImage
              formats={["AUTO", "WEBP", "AVIF"]}
              src="../../../images/captures/kitanomina.png"
              alt="北野未奈の尻作品"
            />
            <p className={styles.firstview_content_title}>北野未奈の尻作品</p>
          </Link>
        </div>
        break
      case 'koumeena':
        targets = 
        <div className={styles.firstview_content}>
          <Link to='/sexyactress-koume-ena/'>
            <StaticImage
              formats={["AUTO", "WEBP", "AVIF"]}
              src="../../../images/captures/koumeena.png"
              alt="小梅えなの尻作品"
            />
            <p className={styles.firstview_content_title}>小梅えなの尻作品</p>
          </Link>
        </div>
        break
      case 'shibasakiyuri':
        targets = 
        <div className={styles.firstview_content}>
          <Link to='/sexyactress-shibasaki-yuri/'>
            <StaticImage
              formats={["AUTO", "WEBP", "AVIF"]}
              src="../../../images/captures/shibasakiyuri.png"
              alt="柴咲ゆうりの尻作品"
            />
            <p className={styles.firstview_content_title}>柴咲ゆうりの尻作品</p>
          </Link>
        </div>
        break
      case 'junelovejoy':
        targets = 
        <div className={styles.firstview_content}>
          <Link to='/sexyactress-june-lovejoy/'>
            <StaticImage
              formats={["AUTO", "WEBP", "AVIF"]}
              src="../../../images/captures/junelovejoy.png"
              alt="ラブジョイの尻作品"
            />
            <p className={styles.firstview_content_title}>ラブジョイの尻作品</p>
          </Link>
        </div>
        break
      case 'shirayukihime':
        targets = 
        <div className={styles.firstview_content}>
          <Link to='/sexyactress-shirayuki-hime/'>
            <StaticImage
              formats={["AUTO", "WEBP", "AVIF"]}
              src="../../../images/captures/shirayukihime.png"
              alt="白雪ひめの尻作品"
            />
            <p className={styles.firstview_content_title}>白雪ひめの尻作品</p>
          </Link>
        </div>
        break
      case 'zinguzinao':
        targets = 
        <div className={styles.firstview_content}>
          <Link to='/sexyactress-zinguzi-nao/'>
            <StaticImage
              formats={["AUTO", "WEBP", "AVIF"]}
              src="../../../images/captures/zinguzinao.png"
              alt="神宮寺ナオの尻作品"
            />
            <p className={styles.firstview_content_title}>神宮寺ナオの尻作品</p>
          </Link>
        </div>
        break
      case 'takiyuina':
        targets = 
        <div className={styles.firstview_content}>
          <Link to='/sexyactress-taki-yuina/'>
            <StaticImage
              formats={["AUTO", "WEBP", "AVIF"]}
              src="../../../images/captures/takiyuina.png"
              alt="滝ゆいなの尻作品"
            />
            <p className={styles.firstview_content_title}>滝ゆいなの尻作品</p>
          </Link>
        </div>
        break
      case 'tachikawarie':
        targets = 
        <div className={styles.firstview_content}>
          <Link to='/sexyactress-tachikawa-rie/'>
            <StaticImage
              formats={["AUTO", "WEBP", "AVIF"]}
              src="../../../images/captures/tachikawarie.png"
              alt="立川理恵の乳作品"
            />
            <p className={styles.firstview_content_title}>立川理恵の乳作品</p>
          </Link>
        </div>
        break
      case 'tanoyu':
        targets = 
        <div className={styles.firstview_content}>
          <Link to='/sexyactress-tano-yu/'>
            <StaticImage
              formats={["AUTO", "WEBP", "AVIF"]}
              src="../../../images/captures/tanoyu.png"
              alt="田野憂の乳作品"
            />
            <p className={styles.firstview_content_title}>田野憂の乳作品</p>
          </Link>
        </div>
        break
      case 'tamakikurumi':
        targets = 
        <div className={styles.firstview_content}>
          <Link to='/sexyactress-tamaki-kurumi/'>
            <StaticImage
              formats={["AUTO", "WEBP", "AVIF"]}
              src="../../../images/captures/tamakikurumi.png"
              alt="玉木くるみの尻作品"
            />
            <p className={styles.firstview_content_title}>玉木くるみの尻作品</p>
          </Link>
        </div>
        break
      case 'chitoseria':
        targets = 
        <div className={styles.firstview_content}>
          <Link to='/sexyactress-chitose-ria/'>
            <StaticImage
              formats={["AUTO", "WEBP", "AVIF"]}
              src="../../../images/captures/chitoseria.png"
              alt="千歳りあの乳作品"
            />
            <p className={styles.firstview_content_title}>千歳りあの乳作品</p>
          </Link>
        </div>
        break
      case 'naganotsukasa':
        targets = 
        <div className={styles.firstview_content}>
          <Link to='/sexyactress-nagano-tsukasa/'>
            <StaticImage
              formats={["AUTO", "WEBP", "AVIF"]}
              src="../../../images/captures/naganotsukasa.png"
              alt="永野つかさの尻作品"
            />
            <p className={styles.firstview_content_title}>永野つかさの尻作品</p>
          </Link>
        </div>
        break
      case 'nanjyoaya':
        targets = 
        <div className={styles.firstview_content}>
          <Link to='/sexyactress-nanjyo-aya/'>
            <StaticImage
              formats={["AUTO", "WEBP", "AVIF"]}
              src="../../../images/captures/nanjyoaya.png"
              alt="南條彩の尻作品"
            />
            <p className={styles.firstview_content_title}>南條彩の尻作品</p>
          </Link>
        </div>
        break
      case 'neoakari':
        targets = 
        <div className={styles.firstview_content}>
          <Link to='/sexyactress-neo-akari/'>
            <StaticImage
              formats={["AUTO", "WEBP", "AVIF"]}
              src="../../../images/captures/neoakari.png"
              alt="根尾あかりの尻作品"
            />
            <p className={styles.firstview_content_title}>根尾あかりの尻作品</p>
          </Link>
        </div>
        break
      case 'hanyuarisa':
        targets = 
        <div className={styles.firstview_content}>
          <Link to='/sexyactress-hanyu-arisa/'>
            <StaticImage
              formats={["AUTO", "WEBP", "AVIF"]}
              src="../../../images/captures/hanyuarisa.png"
              alt="羽生ありさの尻作品"
            />
            <p className={styles.firstview_content_title}>羽生ありさの尻作品</p>
          </Link>
        </div>
        break
      case 'harunanoa':
        targets = 
        <div className={styles.firstview_content}>
          <Link to='/sexyactress-haruna-noa/'>
            <StaticImage
              formats={["AUTO", "WEBP", "AVIF"]}
              src="../../../images/captures/harunanoa.png"
              alt="羽月乃蒼の乳作品"
            />
            <p className={styles.firstview_content_title}>羽月乃蒼の乳作品</p>
          </Link>
        </div>
        break
      case 'miokasatomi':
        targets = 
        <div className={styles.firstview_content}>
          <Link to='/sexyactress-mioka-satomi/'>
            <StaticImage
              formats={["AUTO", "WEBP", "AVIF"]}
              src="../../../images/captures/miokasatomi.png"
              alt="美丘さとみの尻作品"
            />
            <p className={styles.firstview_content_title}>美丘さとみの尻作品</p>
          </Link>
        </div>
        break
      case 'mizuharamisono-2':
        targets = 
        <div className={styles.firstview_content}>
          <Link to='/sexyactress-mizuhara-misono-2/'>
            <StaticImage
              formats={["AUTO", "WEBP", "AVIF"]}
              src="../../../images/captures/mizuharamisono-2.png"
              alt="水原みそのの尻作品"
            />
            <p className={styles.firstview_content_title}>水原みそのの尻作品</p>
          </Link>
        </div>
        break
      case 'mitsuitowa':
        targets = 
        <div className={styles.firstview_content}>
          <Link to='/sexyactress-mitsui-towa/'>
            <StaticImage
              formats={["AUTO", "WEBP", "AVIF"]}
              src="../../../images/captures/mitsuitowa.png"
              alt="蜜井とわの乳作品"
            />
            <p className={styles.firstview_content_title}>蜜井とわの乳作品</p>
          </Link>
        </div>
        break
      case 'yayoimiduki':
        targets = 
        <div className={styles.firstview_content}>
          <Link to='/sexyactress-yayoi-mizuki/'>
            <StaticImage
              formats={["AUTO", "WEBP", "AVIF"]}
              src="../../../images/captures/yayoimizuki.png"
              alt="弥生みづきの尻作品"
            />
            <p className={styles.firstview_content_title}>弥生みづきの尻作品</p>
          </Link>
        </div>
        break
      case 'yukichitose':
        targets = 
        <div className={styles.firstview_content}>
          <Link to='/sexyactress-yuki-chitose/'>
            <StaticImage
              formats={["AUTO", "WEBP", "AVIF"]}
              src="../../../images/captures/yukichitose.png"
              alt="夕季ちとせの乳作品"
            />
            <p className={styles.firstview_content_title}>夕季ちとせの乳作品</p>
          </Link>
        </div>
        break
      case 'washiomei':
        targets = 
        <div className={styles.firstview_content}>
          <Link to='/sexyactress-washio-mei/'>
            <StaticImage
              formats={["AUTO", "WEBP", "AVIF"]}
              src="../../../images/captures/washiomei.png"
              alt="鷲尾めいの乳作品"
            />
            <p className={styles.firstview_content_title}>鷲尾めいの乳作品</p>
          </Link>
        </div>
        break

      case 'review-kitano-seira':
        targets = 
        <div className={styles.firstview_content}>
          <Link to='/review-kitano-seira-tsds42756/'>
            <StaticImage
              formats={["AUTO", "WEBP", "AVIF"]}
              src="../../../images/captures/n_701tsds42756pl.jpg"
              alt="北乃せいらのデカ尻"
            />
            <p className={styles.firstview_content_title}>北乃せいらのデカ尻</p>
          </Link>
        </div>
        break
      case 'review-shibasakiyuri':
        targets = 
        <div className={styles.firstview_content}>
          <Link to='/review-shibasaki-yuri-snd00056/'>
            <StaticImage
              formats={["AUTO", "WEBP", "AVIF"]}
              src="../../../images/captures/h_205snd00056pl.jpg"
              alt="柴咲ゆうりのドム脚"
            />
            <p className={styles.firstview_content_title}>柴咲ゆうりのドム脚</p>
          </Link>
        </div>
        break
      case 'review-yayoimiduki':
        targets = 
        <div className={styles.firstview_content}>
          <Link to='/review-yayoi-miduki-mmyu00003/'>
            <StaticImage
              formats={["AUTO", "WEBP", "AVIF"]}
              src="https://pics.dmm.co.jp/digital/video/mmyu00003/mmyu00003pl.jpg"
              alt="弥生みづきの尻マン開"
            />
            <p className={styles.firstview_content_title}>弥生みづきの尻マン開</p>
          </Link>
        </div>
        break
      case 'review-rino':
        targets = 
        <div className={styles.firstview_content}>
          <Link to='/review-rino-ogy00027/'>
            <StaticImage
              formats={["AUTO", "WEBP", "AVIF"]}
              src="../../../images/captures/n_1353ogy027pl.jpg"
              alt="璃乃のチン媚ポーズ"
            />
            <p className={styles.firstview_content_title}>璃乃のチン媚ポーズ</p>
          </Link>
        </div>
        break

      case 'bigass-1':
        targets = 
        <div className={styles.firstview_content}>
          <a href="https://al.dmm.co.jp/?lurl=https%3A%2F%2Fwww.dmm.co.jp%2Fdigital%2Fvideoa%2F-%2Fdetail%2F%3D%2Fcid%3Drbb00281%2F&af_id=tana0423-014&ch=toolbar&ch_id=link" target="_blank" without rel="noreferrer">
            <StaticImage
              formats={["AUTO", "WEBP", "AVIF"]}
              src="https://pics.dmm.co.jp/digital/video/rbb00281/rbb00281pl.jpg"
              alt="SSS級女優の1等賞の神尻大集合！専属女優＆人気女優選りすぐり大迫力美尻BEST8時間"
            />
            <p className={styles.firstview_content_title}>1等賞の神尻大集合</p>
          </a>
        </div>
        break
      case 'bigass-2':
        targets = 
        <div className={styles.firstview_content}>
          <a href="https://al.dmm.co.jp/?lurl=https%3A%2F%2Fwww.dmm.co.jp%2Fdigital%2Fvideoa%2F-%2Fdetail%2F%3D%2Fcid%3D36dksb00008%2F&af_id=tana0423-014&ch=toolbar&ch_id=link" target="_blank" without rel="noreferrer">
            <StaticImage
              formats={["AUTO", "WEBP", "AVIF"]}
              src="https://pics.dmm.co.jp/digital/video/36dksb00008/36dksb00008pl.jpg"
              alt="エロすぎる美尻素人娘たちの杭打ちピストンディルドオナニー！！15名5時間コレクション"
            />
            <p className={styles.firstview_content_title}>杭打ちピストンオナニー</p>
          </a>
        </div>
        break
      case 'bigass-3':
        targets = 
        <div className={styles.firstview_content}>
          <a href="https://al.dmm.co.jp/?lurl=https%3A%2F%2Fwww.dmm.co.jp%2Fdigital%2Fvideoa%2F-%2Fdetail%2F%3D%2Fcid%3Dpbd00483%2F&af_id=tana0423-014&ch=toolbar&ch_id=link" target="_blank" without rel="noreferrer">
            <StaticImage
              formats={["AUTO", "WEBP", "AVIF"]}
              src="https://pics.dmm.co.jp/digital/video/pbd00483/pbd00483pl.jpg"
              alt="篠田ゆうの最強エロボディで何度も何度も射精したい！BEST 70射精47本番"
            />
            <p className={styles.firstview_content_title}>篠田ゆうの70射精</p>
          </a>
        </div>
        break
      case 'bigass-4':
        targets = 
        <div className={styles.firstview_content}>
          <a href="https://al.dmm.co.jp/?lurl=https%3A%2F%2Fwww.dmm.co.jp%2Fdigital%2Fvideoa%2F-%2Fdetail%2F%3D%2Fcid%3D1fcdss00091%2F&af_id=tana0423-014&ch=toolbar&ch_id=link" target="_blank" without rel="noreferrer">
            <StaticImage
              formats={["AUTO", "WEBP", "AVIF"]}
              src="https://pics.dmm.co.jp/digital/video/1fcdss00091/1fcdss00091pl.jpg"
              alt="デカ尻が綺麗に見えるFALENOガールズのケツ穴丸出しセックス8時間ベスト！"
            />
            <p className={styles.firstview_content_title}>ケツ穴丸出しセックス</p>
          </a>
        </div>
        break

      case 'reserve-1':
        targets = 
        <div className={styles.firstview_content}>
          <a href="https://al.dmm.co.jp/?lurl=https%3A%2F%2Fwww.dmm.co.jp%2Fdigital%2Fvideoa%2F-%2Fdetail%2F%3D%2Fcid%3Dhuntc00321%2F&af_id=tana0423-014&ch=toolbar&ch_id=link" target="_blank" without rel="noreferrer">
            <StaticImage
              formats={["AUTO", "WEBP", "AVIF"]}
              src="https://pics.dmm.co.jp/digital/video/huntc00321/huntc00321pl.jpg"
              alt="『壁尻展覧会』美術部の文化祭の特設コーナーは女子部員たち自らの生尻を展示する壁尻！見て触れて挿れて楽しめるスケベすぎる芸術作品の展覧会！"
            />
            <p className={styles.firstview_content_title}>壁尻展覧会</p>
          </a>
        </div>
        break
      case 'reserve-2':
        targets = 
        <div className={styles.firstview_content}>
          <a href="https://al.dmm.co.jp/?lurl=https%3A%2F%2Fwww.dmm.co.jp%2Fdigital%2Fvideoa%2F-%2Fdetail%2F%3D%2Fcid%3Dflav00384%2F&af_id=tana0423-014&ch=toolbar&ch_id=link" target="_blank" without rel="noreferrer">
            <StaticImage
              formats={["AUTO", "WEBP", "AVIF"]}
              src="https://pics.dmm.co.jp/digital/video/flav00384/flav00384pl.jpg"
              alt="ドスケベ女子校生快楽中毒デカ尻性欲モンスター（FLAV-384）"
            />
            <p className={styles.firstview_content_title}>デカ尻性欲モンスター</p>
          </a>
        </div>
        break
      case 'reserve-3':
        targets = 
        <div className={styles.firstview_content}>
          <a href="https://al.dmm.co.jp/?lurl=https%3A%2F%2Fwww.dmm.co.jp%2Fdigital%2Fvideoa%2F-%2Fdetail%2F%3D%2Fcid%3Daarm00276%2F&af_id=tana0423-014&ch=toolbar&ch_id=link" target="_blank" without rel="noreferrer">
            <StaticImage
              formats={["AUTO", "WEBP", "AVIF"]}
              src="https://pics.dmm.co.jp/digital/video/aarm00276/aarm00276pl.jpg"
              alt="むちむち黒ストッキングの尻に勃起ち〇ぽこすりつけて最後はザーメンぶっかけ！！"
            />
            <p className={styles.firstview_content_title}>黒ストッキングの尻</p>
          </a>
        </div>
        break
      case 'reserve-4':
        targets = 
        <div className={styles.firstview_content}>
          <a href="https://al.dmm.co.jp/?lurl=https%3A%2F%2Fwww.dmm.co.jp%2Fdigital%2Fvideoa%2F-%2Fdetail%2F%3D%2Fcid%3Dmmkz00152%2F&af_id=tana0423-014&ch=toolbar&ch_id=link" target="_blank" without rel="noreferrer">
            <StaticImage
              formats={["AUTO", "WEBP", "AVIF"]}
              src="https://pics.dmm.co.jp/digital/video/mmkz00152/mmkz00152pl.jpg"
              alt="可愛い顔してデカ尻！！羽月乃蒼"
            />
            <p className={styles.firstview_content_title}>羽月乃蒼のデカ尻</p>
          </a>
        </div>
        break

      default:
        targets = 
        <div className={styles.firstview_content}>
          <Link to='/bigtiti/'>
            <StaticImage
              formats={["AUTO", "WEBP", "AVIF"]}
              src="../../../images/captures/bigtiti.png"
              alt="巨乳・爆乳女優26選"
            />
            <p className={styles.firstview_content_title}>巨乳・爆乳女優26選</p>
          </Link>
        </div>
        break
    }
    return (
      <>
        {targets}
      </>
    )
  }
}